import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWrapper from './ModalWrapper';
import ModalCloseButton from './ModalCloseButton';
import Icon from './Icon';
import Button from './Button';

/**
 * 어드민 SaveButton 등 공통 컴포넌트가 트리거하는 성공 안내 모달.
 * - alert('저장되었습니다.') 대체용
 * - 하단 버튼은 '확인' 단일 (브랜드 톤)
 *
 * Props:
 *   open: boolean — 표시 여부
 *   onClose: () => void
 *   title: string  (default: '저장되었습니다')
 *   message: string  (optional)
 */
export default function SuccessAlertModal({ open, onClose, title, message }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <ModalWrapper onClose={onClose} padding="p-5" gap="gap-4" maxWidth="max-w-[460px]" className="relative">
      <div className="absolute top-5 right-5">
        <ModalCloseButton onClick={onClose} />
      </div>
      <div className="flex flex-col items-center text-center gap-3 pt-2">
        <div className="w-14 h-14 rounded-full bg-mono-100 flex items-center justify-center">
          <Icon name="check-circle" size={28} className="text-mono-700" />
        </div>
        <h2 className="text-lg font-bold text-mono-900">{title || t('common.saved')}</h2>
        {message && (
          <p className="text-sm text-mono-600 leading-relaxed break-keep whitespace-pre-line">{message}</p>
        )}
      </div>
      <Button level="dark" fullWidth onClick={onClose}>{t('common.confirm')}</Button>
    </ModalWrapper>
  );
}
